import { services } from "../../const";
import Card from "../ui/Card";
import Text from "../ui/Text";

function Amenities() {
  return (
    <div
      id="services"
      className="sm:px-[30px] px-5 flex flex-col sm:gap-16 gap-8 w-full items-center scroll-m-5"
    >
      <Text type="title">Услуги</Text>
      <div className="grid grid-cols-1 sm:grid-cols-2 sm:gap-5 gap-3">
        {services.map((service) => (
          <Card
            key={service.subtitle}
            className="flex flex-col items-end justify-between sm:gap-11 gap-5"
          >
            <>
              <div className="flex flex-col sm:gap-4 gap-3 ">
                <Text type="subtitle">{service.subtitle}</Text>
                <Text type="main" className="text-gray-main leading-[110%]!">
                  {service.description}
                </Text>
              </div>
              {/* <div className="flex sm:flex-col gap-1 items-end">
                <Text type="subtitle">{service.price}</Text>
                {service.time ? (
                  <Text type="subtitle">{service.time}</Text>
                ) : null}
              </div> */}
            </>
          </Card>
        ))}
      </div>
    </div>
  );
}

export default Amenities;
